export class Versions {
  static readonly APP = "3.15.1";
}
